import React from 'react'
import { t } from '../../../i18n/i18n'
import { List } from '../../common/list/List'
import { Activity } from '../../../api/schemas/schema'
import { DashboardInfoCard } from '../DashboardInfoCard'
import { getDashboardActiviyColumns } from '../../../helpers/dashboardHelper'
import { makeStyles, Text, tokens } from '@fluentui/react-components'
import { ActivityStatusBadge } from '../ActivityStatusBadge'
import { formatDate } from '../../../helpers/stringHelper'
const useStyles = makeStyles({
   phoneBodyWrapper: {
      display: 'flex',
   },
   textColumn: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: tokens.spacingHorizontalS,
   },
   overFlowHidden: {
      overflow: 'hidden',
   },
})

type ActivitiesCardProps = {
   setActivityModalState: React.Dispatch<
      React.SetStateAction<{
         isOpen: boolean
      }>
   >
   latestActivities: Activity[]
}

export const ActivitiesCard = ({ setActivityModalState, latestActivities }: ActivitiesCardProps) => {
   const classes = useStyles()

   return (
      <>
         {latestActivities?.length === 0 ? (
            <DashboardInfoCard
               title={t('PlanYourCalendar')}
               description={t('PlanYourCalendarDescription')}
               buttonText={t('CreateActivity')}
               onClick={() => setActivityModalState({ isOpen: true })}
            />
         ) : (
            <>
               <Text size={600} weight="semibold">
                  {t('AnnualCalendar')}
               </Text>
               <List
                  beigeHeaderBackground
                  className={classes.overFlowHidden}
                  columns={getDashboardActiviyColumns()}
                  items={latestActivities}
                  renderPhoneBodyItem={(item) => (
                     <div className={classes.phoneBodyWrapper}>
                        <ActivityStatusBadge item={item} />
                        <div className={classes.textColumn}>
                           <Text size={400}>{formatDate(item.startDate)}</Text>
                           <Text size={400}>{item.title}</Text>
                        </div>
                     </div>
                  )}
                  columnSizingOptions={{
                     status: { idealWidth: 10, minWidth: 5 },
                     title: { idealWidth: 500, minWidth: 150 },
                     startDate: { idealWidth: 250, minWidth: 100 },
                     endDate: { idealWidth: 250, minWidth: 100 },
                  }}
                  resizableColumns
               />
            </>
         )}
      </>
   )
}
